// Mock data pour le site BS Devis&Plan
export const mockData = {
  company: {
    name: "BS Devis&Plan",
    slogan: "Bureau d'études BTP",
    description: "Spécialistes en devis 2D/3D, chiffrage bâtiment et architecture d'intérieur",
    code: "4399C - Travaux de maçonnerie générale et gros œuvre de bâtiment",
    contact: {
      address: "10 Rue de Port Royal, 78190 Trappes",
      phone: "06 50 24 29 13",
      email: "contact@bsdevisplan.fr",
      hours: {
        weekdays: "08:00 - 17:00",
        saturday: "Fermé",
        sunday: "Fermé"
      }
    }
  },
  
  services: [
    {
      id: 1,
      title: "Plans & Devis 2D/3D",
      description: "Conception de plans techniques précis et modélisations 3D photoréalistes pour visualiser votre projet avant les travaux",
      icon: "PencilRuler",
      features: ["Plans d'exécution", "Modélisation 3D", "Rendus photoréalistes", "Coupes & façades"]
    },
    {
      id: 2,
      title: "Chiffrage & Devis Bâtiment",
      description: "Estimation détaillée et transparente pour maîtriser le budget de votre construction ou rénovation",
      icon: "Calculator",
      features: ["Étude quantitative", "Métrés précis", "Devis chiffré détaillé", "Optimisation des coûts"]
    },
    {
      id: 3,
      title: "Architecture d'Intérieur",
      description: "Aménagement et mise en valeur de vos espaces intérieurs sur-mesure, du concept aux finitions",
      icon: "Palette",
      features: ["Design d'intérieur", "Choix des matériaux", "Ambiances & couleurs", "Suivi de projet"]
    },
    {
      id: 4,
      title: "Accompagnement Gros Œuvre",
      description: "Suivi complet de vos travaux de gros œuvre en partenariat avec Constriva, expert BTP en Île-de-France",
      icon: "HardHat",
      features: ["Suivi de chantier", "Coordination travaux", "Contrôle qualité", "Partenariat Constriva"]
    }
  ],

  partners: [
    {
      id: 1,
      name: "BS Devis&Plan",
      description: "Bureau d'études spécialisé dans les devis et plans de construction",
      specialties: ["Études techniques", "Plans d'exécution", "Métrés", "Chiffrage"],
      logo: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=200&fit=crop&crop=center", // Logo temporaire - sera remplacé par le vrai logo
      contact: "contact@bsdevisplan.fr",
    }
  ],

  projects: [
    {
      id: 1,
      title: "Maison individuelle - Noiseau",
      description: "Construction complète gros œuvre d'une maison de 150m²",
      image: "https://images.unsplash.com/photo-1694521787162-5373b598945c",
      type: "Construction neuve"
    },
    {
      id: 2,
      title: "Rénovation façade - Val-de-Marne",
      description: "Réfection complète de façade et reprise de maçonnerie",
      image: "https://images.unsplash.com/photo-1673865641469-34498379d8af",
      type: "Rénovation"
    },
    {
      id: 3,
      title: "Extension maison - Créteil",
      description: "Extension 40m² avec charpente et couverture",
      image: "https://images.pexels.com/photos/2138126/pexels-photo-2138126.jpeg",
      type: "Extension"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "M. Dupont",
      location: "Noiseau",
      text: "Travail soigné et dans les délais. Équipe professionnelle et à l'écoute.",
      rating: 5
    },
    {
      id: 2,
      name: "Mme Martin", 
      location: "Créteil",
      text: "Très satisfaite de la rénovation. Prix correct et finitions impeccables.",
      rating: 5
    }
  ]
};

export const mockDevis = {
  submitDevis: (data) => {
    console.log('Devis mockée envoyée:', data);
    return Promise.resolve({ 
      success: true, 
      message: 'Votre demande de devis a été envoyée avec succès',
      id: Math.random().toString(36).substr(2, 9)
    });
  }
};